module.exports = "<div class=\"holder widget-rules-wrapper\">\r\n    <div class=\"t-drag-rule-image l-widget-rule s-widget-rule\"></div>\r\n</div>\r\n";